module.exports = __webpack_public_path__ + "static/BannerMobile.db4a5070.jpg";